var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "draft") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "draft",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9397318,5.68818779 C12.7412318,6.49287529 13.5106068,7.26531279 14.3199193,8.07781279 C14.4888568,7.89206279 14.6638568,7.70218779 14.8360443,7.50981279 C15.0582943,7.26143779 15.0656068,7.03343779 14.8316693,6.79462529 C14.2935443,6.24512529 13.7499193,5.70081279 13.1999193,5.16325029 C12.9618568,4.93050029 12.7344193,4.94062529 12.4857318,5.16912529 C12.3022943,5.33775029 12.1242943,5.51231279 11.9397318,5.68818779 M5.99985684,13.9996878 L6.30285684,13.9996878 C6.89610684,13.9996878 7.48979434,14.0127503 8.08216934,13.9908128 C8.23691934,13.9850628 8.42516934,13.9085628 8.53448184,13.8003128 C10.1545443,12.1971878 11.7639818,10.5833128 13.3753568,8.97137529 C13.4376068,8.90906279 13.4937318,8.84068779 13.5226693,8.80850029 C12.7374193,8.01493779 11.9710443,7.24050029 11.1969818,6.45825029 C9.50441934,8.15037529 7.80360684,9.84881279 6.10823184,11.5527503 C6.04491934,11.6163753 6.00560684,11.7325628 6.00448184,11.8248128 C5.99598184,12.5322503 5.99985684,13.2398753 5.99985684,13.9996878 M10.0172943,19.9994378 C4.50329434,20.0105628 0.0163568431,15.5428753 4.43431181e-05,10.0250628 C-0.0162681569,4.50000029 4.47016934,0.00125028864 9.99785684,2.88642665e-07 C15.5132318,-0.00131221136 19.9933568,4.47368779 19.9994818,9.99000029 C20.0056068,15.5048128 15.5344193,19.9882503 10.0172943,19.9994378",
    id: "Fill-1",
    fill: "#7E9596"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.fa3bc85648f1f15fce586dcc96d0a466.svg";
export { ForwardRef as ReactComponent };